import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import styled from 'styled-components';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const ContactContainer = styled.div`
   margin: 0 auto;
  max-width: 1200px;
  padding: 10px 10px;
  background-color: #f9fbfd;
  color: #1a1a1a;
  font-family: 'Segoe UI', sans-serif;
  margin-bottom: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;

const Card = styled.div`
  background-color: #ffffff;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  width: 100%; /* Default full width */
  
  img {
    max-width: 100%; /* Image will take up full width of the card */
    height: auto; /* Automatically adjusts height based on aspect ratio */
    border-radius: 8px;
  }

  @media (min-width: 768px) {
    width: 48%; /* Sidebar form on larger screens */
  }

  @media (min-width: 1024px) {
    width: 30%; /* Image takes 30% of the width and form takes 70% on larger screens */
  }
`;

const FormCard = styled(Card)`
  width: 100%; /* Default full width */
  padding: 40px;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  
  @media (min-width: 768px) {
    width: 65%; /* Form side on larger screens */
  }

  @media (min-width: 1024px) {
    width: 60%; /* Form side on larger screens */
  }

   h2 {
    color: #1a1a1a;
    font-size: 24px;
    margin-bottom: 20px;
  }

  label {
    display: block;
    color: #333;
    margin-bottom: 6px;
    font-weight: 500;
  }

  input,
  textarea {
    width: 100%;
    padding: 12px 14px;
    background-color: #f0f4f8;
    border: 1px solid #ccd6e0;
    border-radius: 10px;
    color: #1a1a1a;
    font-size: 15px;
    outline: none;
    transition: 0.3s ease;
    margin-top: 5px;
    margin-bottom: 5px;

    &:focus {
      border-color: #4aa8ff;
      box-shadow: 0 0 10px #4aa8ff55;
      background-color: #ffffff;
    }
  }

  textarea {
    resize: vertical;
  }

  .submit-button {
    text-align: right;
    margin-top: 20px;
  }

  button {
    background-color: #4aa8ff;
    color: white;
    padding: 12px 26px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #3790e8;
    }
  }
`;

const CaptchaBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 15px;
  background: #eef4fb;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid #c7d8e5;
  font-weight: 500;
  justify-content: space-between;

  span {
    font-family: 'Courier New', monospace;
    font-size: 18px;
    letter-spacing: 2px;
    user-select: none;
    background: #fff;
    padding: 6px 10px;
    border-radius: 6px;
    border: 1px dashed #a5b8c8;
  }

  button {
    background: none;
    color: #4aa8ff;
    border: none;
    cursor: pointer;
    font-size: 14px;
    padding: 4px 8px;
    transition: 0.2s ease;

    &:hover {
      color: #2d7fd6;
      text-decoration: underline;
    }
  }
`;

const RegisterForm = ({ orgid }) => {
    const [form, setForm] = useState({
        name: '',
        phone: '',
        email: '',
        message: '',
    });

    const [captchaText, setCaptchaText] = useState('');
    const [captchaInput, setCaptchaInput] = useState('');
    const [PhoneNo, setPhoneNo] = useState(null);
    // Generate random 5-character CAPTCHA
    const generateCaptcha = () => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
        let text = '';
        for (let i = 0; i < 5; i++) text += chars.charAt(Math.floor(Math.random() * chars.length));
        setCaptchaText(text);
        setCaptchaInput('');
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone" && !/^\d*$/.test(value)) return;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (captchaInput.trim().toUpperCase() !== captchaText) {
            Swal.fire({
                title: 'Captcha Incorrect!',
                text: 'Please enter the correct characters shown.',
                icon: 'error',
                confirmButtonColor: '#4aa8ff',
            });
            generateCaptcha();
            return;
        }

        try {
            const sendData = {
                UserId: 7,
                OrgId: Number(orgid),
                WebHeader: "PrustrySirRegistration",
                MainDesc: String(PhoneNo),
                ColumRemarks: form.name,
                Oremarks: form.email,
                Remarks: form.message,
            };

            //console.log("Send: ", sendData)

            const response = await fetch('https://zaingielatestapi.azurewebsites.net/api/Main/AddInfolist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(sendData),
            });

            Swal.fire({
                title: 'Success!',
                text: 'Your registration has been sent successfully.',
                icon: 'success',
                confirmButtonColor: '#4aa8ff',
            });

            setForm({ name: '', phone: '', email: '', message: '' });
            setPhoneNo(null)
            generateCaptcha();
        } catch (error) {
            console.error("Form submission failed:", error);
            alert('Failed to submit. Please try again later.');
        }
    };

    return (
        <ContactContainer>
            {/*<Card>*/}
            {/*    <img src="images/eternal.png" alt="Eternal" />*/}
            {/*</Card>*/}
            <FormCard>
                <h2>Enter a details</h2>
                <form onSubmit={handleFormSubmit}>
                    <label htmlFor="name">Name</label>
                    <input name="name" type="text" value={form.name} onChange={handleInputChange} required />

                    <label htmlFor="phone">Phone Number</label>
                    {/*<input name="phone" type="text" value={form.phone} onChange={handleInputChange} maxLength="15" required />*/}
                    <PhoneInput
                        country={'in'}
                        inputProps={{
                            name: 'phone',
                            required: true,
                            autoFocus: true
                        }}
                        value={PhoneNo }
                        onChange={(phone) => setPhoneNo(phone)}
                        inputStyle={{ width: "100%", height: "100%", backgroundColor: "#f0f4f8", border: "1px solid #ccd6e0", borderRadius: "10px", color: "#1a1a1a", fontSize: "15px", outline: "none", transition: "0.3s easy" }}
                        containerStyle={{marginTop:"5px", marginBottom:"10px",  borderRadius: "10px"} }
                    />
                       

                    <label htmlFor="email">Email</label>
                    <input name="email" type="email" value={form.email} onChange={handleInputChange} required />

                 {/*   <label htmlFor="message">Message</label>
                    <textarea name="message" rows="4" value={form.message} onChange={handleInputChange} required />*/}

                    <CaptchaBox>
                        <span>{captchaText}</span>
                        <button type="button" onClick={generateCaptcha}>↻ Refresh</button>
                    </CaptchaBox>

                    <input
                        type="text"
                        placeholder="Enter the above text"
                        value={captchaInput}
                        onChange={(e) => setCaptchaInput(e.target.value)}
                        style={{
                            marginTop: '10px',
                            width: '100%',
                            padding: '10px 12px',
                            borderRadius: '8px',
                            border: '1px solid #ccd6e0',
                            fontSize: '15px'
                        }}
                        required
                    />

                    <div className="submit-button">
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </FormCard>
        </ContactContainer>
    );
};

export default RegisterForm;
